import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { marketplaceChipLabel } from '../../pages/fulfillmentUi.mjs';

export function TsdCabinetSelect({
  id,
  accounts = [],
  accountId,
  onChange,
  disabled = false,
}) {
  if (!accounts.length) return null;
  return (
    <FormControl size="small" fullWidth>
      <InputLabel id={id}>Кабинет</InputLabel>
      <Select
        labelId={id}
        label="Кабинет"
        value={accountId}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        {accounts.map((account) => (
          <MenuItem key={account.id} value={String(account.id)}>
            {marketplaceChipLabel(account.marketplace)}
            {' · '}
            {account.name || account.organization || `ID ${account.id}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default function TsdPageBar({ title, startAdornment = null, extra = null }) {
  return (
    <Box sx={{ mb: 2.5, pt: 0.5 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minWidth: 0,
          mb: extra ? 1.5 : 0,
        }}
      >
        {startAdornment}
        {title ? (
          <Typography variant="h5" fontWeight="bold" noWrap sx={{ minWidth: 0 }}>
            {title}
          </Typography>
        ) : null}
      </Box>
      {extra ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flexWrap: 'wrap',
          }}
        >
          {extra}
        </Box>
      ) : null}
    </Box>
  );
}
